import type { Location } from "./types";

const COUNTRY_TIMEZONE_FALLBACK: Record<string, string> = {
  pakistan: "Asia/Karachi",
  india: "Asia/Kolkata",
  bangladesh: "Asia/Dhaka",
  saudiarabia: "Asia/Riyadh",
  saudi_arabia: "Asia/Riyadh",
  uae: "Asia/Dubai",
  "unitedarabemirates": "Asia/Dubai",
  qatar: "Asia/Qatar",
  kuwait: "Asia/Kuwait",
  oman: "Asia/Muscat",
  bahrain: "Asia/Bahrain",
  turkey: "Europe/Istanbul",
  morocco: "Africa/Casablanca"
};

function normalizeCountry(input?: string): string {
  return String(input ?? "").toLowerCase().replace(/[^a-z]/g, "");
}

export function browserTimeZone(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof tz === "string" ? tz.trim() : "";
  } catch {
    return "";
  }
}

export function fallbackTimeZoneForCountry(country?: string): string {
  return COUNTRY_TIMEZONE_FALLBACK[normalizeCountry(country)] ?? "";
}

export function pickBestTimeZone(loc: Pick<Location, "country" | "timezone">, preferred?: string): string {
  // A location's OWN timezone (from a city pick, the shared landing widget key,
  // or IP-geo) must win over the device's browser timezone — otherwise viewing a
  // city in a different zone (e.g. Istanbul on a device set to Asia/Karachi)
  // would show the device's zone. Browser tz is only a fallback when the
  // location carries no usable zone.
  const candidates = [preferred, loc.timezone, browserTimeZone(), fallbackTimeZoneForCountry(loc.country)]
    .map((v) => String(v ?? "").trim())
    .filter(Boolean)
    .filter((v) => v.toUpperCase() !== "UTC");

  return candidates[0] ?? String(loc.timezone ?? "").trim() ?? "UTC";
}

export function calibrateLocation(loc: Location, preferredTimeZone?: string): Location {
  return {
    ...loc,
    timezone: pickBestTimeZone(loc, preferredTimeZone)
  };
}
